import "./Reports.css";

const comingSoonHref = "/pdfs/reports-coming-soon.html";

const reports = [
  {
    year: "2024",
    report: comingSoonHref,
  },
  {
    year: "2023",
    report: comingSoonHref,
  },
  {
    year: "2022",
    report: comingSoonHref,
  },
];

export default function Reports() {
  return (
    <section className="Reports" id="reports">
      <div className="Reports__container">

        <h2 className="Reports__title">
          Our Annual Reports &amp; Organizational Strategy
        </h2>

        <p className="Reports__description">
          Our reports are released on a bi-annual basis and our organizational
          strategy details a six-year plan for Pangolino.
        </p>

        <div className="Reports__featured">

          <a
            href={comingSoonHref}
            target="_blank"
            rel="noopener noreferrer"
            className="Reports__button"
          >
            Organizational Strategy coming soon
          </a>

          <a
            href={comingSoonHref}
            target="_blank"
            rel="noopener noreferrer"
            className="Reports__button"
          >
            2025 Annual Report coming soon
          </a>

        </div>

        <div className="Reports__history">

          {reports.map((item) => (
            <div
              className="Reports__year"
              key={item.year}
            >
              <a
                href={item.report}
                target="_blank"
                rel="noopener noreferrer"
                className="Reports__historyButton"
              >
                {item.year} Annual Report coming soon
              </a>

            </div>
          ))}

        </div>

      </div>

      <div className="Reports__divider" />

    </section>
  );
}